import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    header: {
      width: "100%",
      padding: "0 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: 16
    },
    managementTracksContent: {
      width: "100%",
      backgroundColor: "#fff"
    },
    managementHeader: {
      width: "100%",
      padding: "0 20px",
      display: "flex",
      alignItems: "center",
      fontSize: 16
    },
    swipeableSlide: {
      height: "calc(100dvh - 124px)",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        height: `calc((var(--vh, 1vh) * 100) - 116px)`
      }
    },
    managementHeaderPart: {
      display: "flex",
      alignItems: "center"
    },
    selectTrackButton: {
      color: primary.dark,
      fontSize: 14,
      cursor: "pointer",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        lineHeight: 1
      }
    },
    selectedBlack: {
      color: primary.main,
      fontWeight: 600
    },
    rightArrow: {
      fontSize: 14,
      margin: "0 6px",
      color: primary.dark
    },
    selectedFacilityName: {
      color: primary.dark,
      fontSize: 14,
      cursor: "pointer",
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        lineHeight: 1
      }
    },
    selectedAppName: {
      color: primary.dark,
      fontSize: 14,
      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        lineHeight: 1
      }
    },
    selectedGreen: {
      color: secondary.dark,
      cursor: "default"
    },
    closeIcon: {
      fontSize: 28,
      "&:hover": {
        cursor: "pointer"
      }
    },
    dividerLight: {
      backgroundColor: "#eee"
    },
    headerDisabled: {
      opacity: 0.5
    },
    slideContainer: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      width: "100%"
    },
    swipeContainer: {
      height: "100%",
      "& .react-swipeable-view-container": {
        height: "100%"
      },
      "& $swipeElement": {
        [theme.breakpoints.down(Breakpoints.SM_600)]: {
          overflow: "initial !important"
        }
      }
    },
    swipeElement: {
      display: "flex",
      flexDirection: "column",
      height: "100%"
    }
  };
});
